import React, { useMemo, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  flexRender,
} from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

const TableComponent = ({
  columns,
  data,
  totalCount,
  pageSize = 10,
  filteredOptions = [],
}) => {
  const [globalFilter, setGlobalFilter] = React.useState("");
  const { t } = useTranslation();
  const table = useReactTable({
    columns,
    data: data,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    manualPagination: true,
    pageCount: Math.ceil(totalCount / pageSize),
  });

  return (
    <div className="mx-auto w-full ">
      <div className="overflow-auto min-h-[480px] ">
        {data.length > 0 ? (
          <table className="w-full border  border-gray-300 rounded-md shadow-sm">
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id} className="bg-gray-100">
                  {headerGroup.headers.map((header) => (
                    <th
                      key={header.id}
                      className="py-3 px-6 text-center text-md font-bold text-gray-600 border"
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody className="">
              {table.getRowModel().rows.map((row, index) => (
                <tr
                  key={row.id}
                  className={`
                  
                    bg-white hover:bg-gray-100`}
                >
                  {row.getVisibleCells().map((cell) => (
                    <td
                      key={cell.id}
                      className="py-3 px-6 text-center text-sm lg:text-md text-black  border"
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-center py-6 text-gray-500 min-h-[480px]">
            {t("usedCars.messages.noData")}
          </div>
        )}
      </div>
    </div>
  );
};

// Example columns definition
export const defaultColumns = [
  {
    header: "ID",
    accessorKey: "id",
  },
  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "Email",
    accessorKey: "email",
  },
];

export default TableComponent;
